<template>
  <header :class="[bem(), isWXApp || client, appVersion, isForceShow, isVivoAppNoOS4]" v-if="!isHide || forceShow">
    <div class="header__placeholder"></div>
    <div class="fill" :style="{ height: nativeHeight }" v-if="env.isIOSVivoApp"></div>
    <div :class="header" :style="{ backgroundColor: headerBg, top: nativeHeight }">
      <a href="javascript:;" v-if="backShow" @click="goBack" class="header__link header__link_back">
        <v-icon class="icon-back" name="arrow-left-v3"></v-icon>
      </a>
      <h1 class="header__title" @click="toTop">{{ pageTitle }}</h1>
      <a
        href="https://www.vivo.com.cn/search/index"
        class="header__link header__search"
        v-if="search"
        v-track="[{ act: 'click', params: { cfrom: 5126, search_page: 3 } }]"
      >
        <v-icon class="icon-search" name="search-v2"></v-icon>
        <!-- <div class="icon-search"></div> -->
      </a>
      <a v-if="showMenuIcon" class="header__link header__link_menu" href="javascript:;" @click="handleToggleMenu">
        <v-icon class="icon-menu" name="icon-menu-v3"></v-icon>
      </a>
      <div class="tips" v-if="rightText" @click="handleRightClick">{{ rightText }}</div>
    </div>
    <v-header-menu v-if="isShowIdx" :isShowMenu="isShowMenu" @close="closeMenu"></v-header-menu>
    <v-search :show="isShowSearch" @close="isShowSearch = false"></v-search>
  </header>
</template>

<script>
import env from 'utils/clientEnv'
import { goBack } from 'utils/common'
import shop from 'utils/shop'
import create from '../create'
import { app } from '@/utils'

export default create({
  name: 'header',
  props: {
    name: {
      type: String,
      default: ''
    },
    search: {
      type: Boolean,
      default: false
    },
    headerBg: {
      type: String,
      default: ''
    },
    forceShow: {
      type: Boolean,
      default: false
    },
    backShow: {
      type: Boolean,
      default: true
    },
    showMenuIcon: {
      type: Boolean,
      default: true
    },
    rightText: {
      type: String,
      default: ''
    },
    // 回滚到顶部自定义方法
    toTopCallBack: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      // 默认显示，如果url中noHeader或者UA中noHeader为true，则不显示头部
      isHide: shop.isHidenHeader() || shop.hidenShopHeader(),
      isShowMenu: false,
      isShowIdx: 0,
      isShowSearch: false,
      isWXApp: '',
      nativeHeight: '',
      env
    }
  },
  computed: {
    header() {
      // 样式改版
      return ['header__normal']
    },
    // 官网app且不是OS4系统
    isVivoAppNoOS4() {
      if (env.isVivoApp && !env.isOS4 && !env.isIOSVivoApp) {
        return 'vivo-app-no-os-4'
      }
      return ''
    },
    pageTitle() {
      return this.name || this.$route.meta.title || this.$route.name
    },
    client() {
      let clientType = ''

      if (env.isWx) {
        clientType = 'wx'
      } else if (env.isAlipay) {
        clientType = 'alipay'
      } else if (env.isVivoApp) {
        clientType = 'vivoapp'
      } else if (env.isVHome) {
        clientType = 'vhome'
      } else if (env.isBankabc) {
        clientType = 'bankabc'
      } else if (env.isGameCenter) {
        clientType = 'gamecenter'
      } else if (env.isAppStore) {
        clientType = 'appstore'
      } else if (env.isiMusic) {
        clientType = 'imusic'
      } else if (env.isiTheme) {
        clientType = 'itheme'
      } else if (env.isVivoVideo) {
        clientType = 'vivovideo'
      } else if (env.isWallet) {
        clientType = 'vivowallet'
      } else if (env.isJovi) {
        clientType = 'jovi'
      }

      return clientType
    },
    appVersion() {
      if (!env.isVivoApp) return ''

      return `v-${env.appVersion}` || ''
    },
    isForceShow() {
      return this.forceShow ? 'force-show' : ''
    }
  },
  watch: {
    pageTitle(val) {
      document.title = val
    }
  },
  created() {
    // 改变页面title
    document.title = this.pageTitle

    // 判断是否是小程序
    env.isWeChatApp().then(res => {
      if (res) {
        this.isWXApp = 'wxapp'
      }
    })
    app.getTitleBarHeight({
      type: 'statusBarHeight',
      success: res => {
        if (env.isIOSVivoApp) {
          this.nativeHeight = `${res}px`
        }
      }
    })
  },
  methods: {
    closeMenu() {
      this.isShowMenu = false
    },
    handleToggleMenu() {
      this.isShowMenu = !this.isShowMenu
      // 优化首次子菜单图标不加载
      this.isShowIdx++
    },
    goBack() {
      goBack()
    },
    toTop() {
      if (this.toTopCallBack) {
        this.toTopCallBack()
      } else {
        document.documentElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    },
    handleRightClick() {
      this.$emit('rightClick')
    }
  }
})
</script>

<style lang="scss" scoped src="./index.scss"></style>
